/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import React from 'react';
import styles from './Tab.module.css';
export default function TabGroup({
    tabs = [],
    activeId,
    onChange,
    selectedId = null,
    onSelect = null,
    allowSelection = false,
    fullWidth = false,
    className = ''
}) {
    const handleClick = (id) => {
        if (id === activeId && allowSelection) {
            onSelect?.(selectedId === id ? null : id);
        } else {
            onChange?.(id);
            if (allowSelection) onSelect?.(null);
        }
    };
    return (
        <div className={`${styles.tabs} ${fullWidth ? styles.fullWidth : ''} ${className}`}>
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    className={`
                        ${styles.tab} 
                        ${activeId === tab.id ? styles.active : ''} 
                        ${selectedId === tab.id ? styles.selected : ''}
                    `}
                    onClick={() => handleClick(tab.id)}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
}
